<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Consulta historial asignacion Orden/Pedido
            </h2>
            <small class="title-description">
                Consultas
            </small>
        </div>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Numero de documento</mat-label>
            <input matInput type="text" placeholder="Buscar" (keyup)="consultar($event)" #input>
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>
</div>

<div class="shadow mt-3">
    <coky-table [title]="'Resultado'" [data]="ordenes">
    </coky-table>
</div>